const translation = {
  add_client: {
    en: 'add client',
    fr: 'ajouter client',
  },
  clients: {},
  locations: {},
  pro: {},
  logout: {
    fr: 'Déconnexion'
  },
  name: {
    fr: 'nom',
  },
  me: {
    fr: 'moi'
  },
  assignee: {
    fr: 'assigné à'
  },
  address: {
    fr: 'adresse'
  },
  description: {},
  current_plan: {
    en: 'current plan',
    fr: 'plan actuel'
  },
  select_this_plan: {
    en: 'select plan',
    fr: 'sélectionnez ce plan'
  },
  full_name: {
    en: 'Full Name',
    fr: 'Nom Complet'
  },
  people: {
    fr: 'personnes',
  },
  professional: {
    en: 'Professional',
    fr: 'Professionnel',
  },
  plan_features: {
    en: 'plan features',
    fr: 'caractéristiques du plan'
  },
  choose_plan: {
    en: 'choose a plan',
    fr: 'choisir un plan'
  },
  something_wrong: {
    en: 'Something went wrong, please try again',
    fr: "Quelque chose n'a pas fonctionné, svp essayer à nouveau",
  },
  something_wrong_payment: {
    en: 'Something went wrong with your payment',
    fr: "Quelque chose n'a pas fonctionné avec le paiement"
  },
  month: {
    fr: 'mois',
  },
  'Unlimited Clients': {
    fr: 'Clients illimités',
  },
  'Unlimited Locations': {
    fr: 'Emplacements illimités',
  },
  'Up to 35 Employees': {
    fr: 'Jusqu’à 35 employés',
  },
  'Up to 3 Employees': {
    fr: 'Jusqu’à 3 employés',
  },
  'Any number of Administrators': {
    fr: "Nombre illimité d'Administrateurs",
  },
  '1 Administrator': {
    fr: '1 Administrateur'
  },
  invitee_removed: {
    en: 'Invitee removed',
    fr: 'Invité supprimé'
  },
  admin: {
    fr: 'Administrateur'
  },
  worker: {
    fr: 'travailleur'
  },
  'One User': {
    fr: 'Un Utilisateur',
  },
  basic: {
    fr: 'de base',
  },
  Step: {
    fr: 'Étape',
  },
  'Payment Details': {
    fr: 'Modalités de Paiement',
  },
  subscription_start: {
    en: 'Your subscription will start immediately.',
    fr: 'Votre abonnement commencera immédiatement',
  },
  free_trial: {
    en: 'All plans include a 60 day free trial.',
    fr: 'Tout les plans incluent un essai gratuit de 60 jours.'
  },
  'No payment required': {
    fr: 'Aucun paiment requis'
  },
  subscribe: {
    fr: "s'inscrire"
  },
  payment_updated: {
    en: 'Payment info successfully updated',
    fr: 'Informations de paiement mises à jour avec succés'
  },
  'Update Credit Card Information': {
    fr: 'Mettre à jour la Carte de Crédit'
  },
  'Sign up': {
    fr: "S'enregistrer"
  },
  'Sign In': {
    en: 'Sign In',
    fr: 'Connexion'
  },
  register: {
    fr: "S'inscrire"
  },
  'phone': {
    fr: 'téléphone'
  },
  phone_number: {
    en: 'Phone number',
    fr: 'numéro de téléphone'
  },
  email: {
    fr: 'e-mail'
  },
  'Login email': {
    fr: 'E-mail de connexion'
  },
  role: {
    fr: 'rôle'
  },
  'Primary Email': {
    fr: 'E-mail principal'
  },
  valid_email: {
    en: 'Please enter a valid email',
    fr: 'Svp entrer un e-mail valide'
  },
  password: {
    fr: 'mot de passe'
  },
  'Confirm password': {
    fr: 'Confirmer mot de passe'
  },
  valid_password_message: {
    en: 'Please enter a valid password',
    fr: 'Svp entrer un mot de passe valide'
  },
  password_rules: {
    en: 'Password must be at least 12 characters long',
    fr: 'Mot de passe doit être au moins 12 caractères de long'
  },
  password_match: {
    en: 'Passwords do not match',
    fr: 'Mots de passe ne correspondent pas'
  },
  reset_password: {
    en: 'Reset my password',
    fr: 'Réinitialiser mon mot de passe'
  },
  'Create a new password': {
    fr: 'Créer un nouveau mot de passe'
  },
  'Back to Sign In': {
    fr: 'Retour a Connexion'
  },
  incorrect_credentials: {
    en: 'Your login credentials are incorrect',
    fr: 'Vos informations d’identification de connexion sont incorrectes'
  },
  'Company Name': {
    fr: 'Nom de Compagnie'
  },
  'Please enter a Client name': {
    fr: 'Svp entrer nom du Client'
  },
  'Please enter a contact name': {
    fr: "Svp entrer le nom d'un contact"
  },
  'Please enter a phone number': {
    fr: 'Svp entrer un numéro de téléphone'
  },
  'Please enter a Location name': {
    fr: "Svp entrer un nom d'Emplacement"
  },
  'Please enter a name': {
    fr: 'Svp entrer un nom'
  },
  'Get Started': {
    fr: 'Commencer'
  },
  terms_conditions_privacy: {
    en: 'Terms & Conditions || Privacy Policy',
    fr: 'Conditions Générales || Politique de Confidentialité'
  },
  register_agree: {
    en: 'By registering up you agree to our ',
    fr: 'En vous inscrivant, vous acceptez nos '
  },
  terms_conditions_and_privacy: {
    en: 'Terms & Conditions as well as our Privacy Policy',
    fr: 'conditions générales ainsi que notre politique de confidentialité'
  },
  check_email_password_reset: {
    en: 'Check your email for a link to create a new password',
    fr: 'Vérifier votre e-mail pour un lien pour créer un nouveau mot de passe'
  },
  dont_have_account: {
    en: "Don't have an account yet?",
    fr: "Vous n'avez pas encore de compte?"
  },
  'Register Today': {
    fr: "S'inscrire aujourd'hui"
  },
  trouble_signing_in: {
    en: 'Having trouble signing in?',
    fr: 'Problèmes de connexion?'
  },
  'Generate Report': {
    fr: 'Générer Rapport'
  },
  'Select Dates': {
    fr: 'Sélectionner les dates'
  },
  'Select Client': {
    fr: 'sélectionner le client'
  },
  'Select Assignee': {
    fr: 'Sélectionner la personne assignée'
  },
  start_date: {
    en: 'Start Date',
    fr: 'Date de Début'
  },
  end_date: {
    en: 'End Date',
    fr: 'Date de Fin'
  },
  'Get Report': {
    fr: 'Obtenir un Rapport'
  },
  close: {
    fr: 'fermer'
  },
  'Sign Below': {
    fr: 'Signer ci-dessous'
  },
  signer_name: {
    en: "Signer's Name",
    fr: 'Nom du Signataire'
  },
  signature: {},
  'Add a note': {
    fr: 'Ajouter une note'
  },
  'Notes': {},
  'Log Recorded':{
    fr: 'journal enregistré'
  },
  show: {
    fr: 'Montrer'
  },
  hide: {
    fr: 'Masquer'
  },
  'Client Name': {
    fr: 'Nom du Client'
  },
  contact_name: {
    en: 'Contact Name',
    fr: 'Nom du Contact'
  },
  'Client Added': {
    fr: 'Client ajouté'
  },
  'Clients Locations': {
    fr: 'Emplacements du Client'
  },
  'Client Updated': {
    fr: 'Client mise à jour'
  },
  'No Locations': {
    fr: 'Aucun emplacement'
  },
  'An account with this email already exists': {
    fr: "Un utilisateur avec cet email existe déjà"
  },
  no_locations_admin_header: {
    en: 'Looks like there are no locations added yet.',
    fr: "On dirait qu'il n'y a pas encore d'enplacements ajoutés"
  },
  no_locations_admin_text: {
    en: 'Use the "Add Location" button above to add your first Location!',
    fr: 'Utlisez le bouton "Ajouter Emplacement" ci-dessus pour ajouter votre premier emplacement!'
  },
  no_locations_worker_header: {
    en: 'Looks like there you have no locations assigned to you yet.',
    fr: ''
  },
  no_locations_worker_text: {
    en: 'Contact your employer to get locations assigned to you.',
    fr: ''
  },
  no_clients: {
    en: 'Looks like there are no clients added yet.',
    fr: "Aucun nouveau client d'ajouté pour le moment"
  },
  no_logs: {
    en: 'Looks like there are no work Logs added yet.',
    fr: "Il n'y a aucun registre de travail pour le moment."
  },
  log_work: {
    en: 'Log Work',
    fr: 'Enregistrer Travaux'
  },
  add_client_text: {
    en: 'Use the "Add Client" button above to add your first client!',
    fr: "Utliliser le bouton 'Ajouter Client' ci-dessus pour ajouter votre premier client!"
  },
  add_new_client: {
    en: 'Add New Client',
    fr: 'Ajouter un Nouveau client'
  },
  'Add Location': {
    fr: 'Ajouter Emplacement'
  },
  'Location Added': {
    fr: 'Emplacement Ajouté'
  },
  'Location Name': {
    fr: "Nom d'Emplacement"
  },
  'Location Logs': {
    fr: "Registre d'Emplacements"
  },
  'Location Updated': {
    fr: 'emplacement mis à jour '
  },
  'Assigned Locations': {
    fr: 'Emplacements Assignés'
  },
  no_locations_assigned: {
    en: 'There are no locations assigned to this user.',
    fr: "Il n'y a aucun emplacement d'assigné à cet utilisateur."
  },
  user_info: {
    en: 'user information',
    fr: 'informations utilisateur'
  },
  complete_registration: {
    en: 'To complete your registration follow the link sent to:',
    fr: 'Pour compléter votre inscription suivez le lien envoyé à:'
  },
  time_stamp: {
    en: 'Time stamp',
    fr: 'Horodatage'
  },
  last_serviced: {
    en: 'Last serviced',
    fr: 'Date du dernier entretien'
  },
  cancel: {
    fr: 'annuler'
  },
  update: {
    fr: 'mettre à jour'
  },
  delete: {
    fr: 'Supprimer'
  },
  edit: {
    fr: 'Modifier'
  }
  ,'Invitation sent to': {
    fr: 'invitation envoyée à'
  },
  invited_users: {
    en: 'Invited users',
    fr: 'Utilisateurs Invités'
  },
  invited_role: {
    en: 'Invited Role',
    fr: 'Rôle Invité'
  },
  add_person: {
    en: 'Add Person',
    fr: 'Ajouter Personne'
  },
  'User Updated': {
    fr: 'Utilisateur mise à jour'
  },
  'You can not delete the main registered account': {
    fr: 'Vous ne pouvez pas supprimer le compte principal'
  },
  delete_person_message: {
    en: `
      This will delete this user permanently.
      This action can not be undone.
    `,
    fr: `
      Cela supprimera cet utilisateur de façon permanente.
      Cette action est irreversible.
    `
  },
  'User has been deleted': {
    fr: 'Utilisateur a été supprimé'
  },
  location_services: {
    en: 'Please ensure location services are turned on, and that you are close enough to the location.',
    fr: 'Veuillez vous assurer que les services de localisation sont activés et que vous êtes suffisamment proche de l\'emplacement.'
  },
  invite_removed: {
    en: 'Invite removed',
    fr: 'Invitation supprimée'
  },
  subscription_inactive: {
    en: "There is a problem with the account. Please contact your employer or account admin.",
    fr: "Il y a un problème avec le compte. Veuillez contacter votre employeur ou l'administrateur de votre compte"
  },
  subscription_inactive_admin: {
    en: "There seems to be a problem with your payment method. Please update your payment information",
    fr: "Il semble y avoir un problème avec votre mode de paiement. Veuillez mettre à jour vos informations de paiement"
  },
  no_payment_plan_error: {
    en: 'You must add a payment method to continue',
    fr: 'Vous devez ajouter un mode de paiement pour continuer'
  },
  no_active_plan: {
    en: 'You are not subscribed to a plan. Please choose a plan to continue',
    fr: "Vous n'êtes pas abonné à un plan. Veuillez choisir un plan pour continuer"
  },
  too_many_users: {
    en: 'You have too many active or invited users to use this plan.',
    fr: "Vous avez trop d'utilisateurs actifs ou invités à utiliser ce plan."
  },
  daily_report: {
    en: 'Daily report',
    fr: 'Rapport quotidien'
  },
  change_plan_button: {
    en: (selectedPlan) => `Change to the ${selectedPlan} plan`,
    fr: (selectedPlan) => `Modification du plan ${selectedPlan}`
  },
  cancel_subscription: {
    en: "Cancel subscription",
    fr: "annuler l'abonnement"
  },
  settings: {
    en: 'Settings',
    fr: 'Paramètres'
  },
  settings_updated: {
    en: 'Settings Updated',
    fr: 'Mis à jour paramètres'
  },
  success: {
    fr: 'succès'
  },
  warning: {
    fr: 'attention'
  },
  error: {
    fr: 'erreur'
  },
  search: {
    fr: 'rechercher'
  }
}

export default translation
